import { faArrowRotateRight } from "@fortawesome/pro-thin-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";

interface RefreshButtonProps {
  onRefresh: () => void | Promise<unknown>;
  disabled?: boolean;
  label?: string;
  fullWidth?: boolean;
}

export function RefreshButton(props: RefreshButtonProps) {
  const { onRefresh, disabled = false, label = "Refresh", fullWidth = false } = props;
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (isRefreshing || disabled) return;

    setIsRefreshing(true);
    try {
      const result = onRefresh();
      if (result && typeof result === "object" && "then" in result) {
        await result;
      }
    } catch (error) {
      console.error("Refresh failed:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <Button
      variant="outlined"
      onClick={handleRefresh}
      disabled={disabled || isRefreshing}
      startIcon={isRefreshing ? <CircularProgress size={16} /> : <FontAwesomeIcon icon={faArrowRotateRight} />}
      fullWidth={fullWidth}
      sx={{ height: 50 }}
    >
      {label}
    </Button>
  );
}
